import React, { useContext } from "react";
import { DatePicker, App } from "antd";
import dayjs from "dayjs";
import "./SubHeader.scss";
import { AppContext } from "../../context/Context";

const { RangePicker } = DatePicker;

const SubHeader = ({ title }) => {
  const { fromDate, toDate, setFromDate, setToDate, data } = useContext(AppContext);
  const { message } = App.useApp();

  // Handle user selecting or clearing the date range
  const handleRangeChange = (values) => {
    if (values && values.length === 2) {
      const start = values[0].format("YYYY-MM");
      const end = values[1].format("YYYY-MM");
      setFromDate(start);
      setToDate(end);
      message.success(`Date range selected: ${start} → ${end}`);
    } else {
      // When cleared → set default to "All"
      setFromDate("All");
      setToDate("");
      message.info("Showing all data.");
    }
  };

  // Disable current & future months (unless 'All' mode)
  // const disabledDate = (current) => {
  //   if (fromDate === "All" && toDate === "") return false; // allow all months
  //   if (!current) return false;

  //   const startOfCurrentMonth = dayjs().startOf("month");
  //   return (
  //     current.isSame(startOfCurrentMonth, "month") ||
  //     current.isAfter(startOfCurrentMonth, "month")
  //   );
  // };
  const disabledDate = (current) => {
    if (!current) return false;

    // Define allowed date range
    const minDate = dayjs(data.firstdate, "YYYY-MM").startOf("month");
    const maxDate = dayjs(data.lastdate, "YYYY-MM").endOf("month");

    // Disable anything outside that range
    return current.isBefore(minDate, "month") || current.isAfter(maxDate, "month");
  };


  return (
    <div className="frame-sub-header">
      <div>
        <h2>FR EXPENSE & BUDGET DASHBOARD</h2>
        <h3>{title}</h3>
      </div>

      <RangePicker
        picker="month"
        format="YYYY-MM"
        onChange={handleRangeChange}
        value={
          fromDate === "All"
            ? null // visually clear picker when in "All" mode
            : fromDate && toDate
            ? [dayjs(fromDate, "YYYY-MM"), dayjs(toDate, "YYYY-MM")]
            : null
        }
        size="large"
        disabledDate={disabledDate}
        allowClear
      />
    </div>
  );
};

export default SubHeader;
